export default {
  "home.start_now": "立即开始",
  "home.tips.all_free": "免费使用",
  "home.tips.no_download_required": "无需下载",
  "home.tips.no_payment_required": "无需付费",
  "home.tips.no_registration_required": "无需注册",
  "home.tips.no_subscription_required": "无需订阅",
  "home.welcome_to": "欢迎来到",
};
